<template>
    <div>
        <tit data-aos="fade-up" class="tit--lg white--text">
            어떠한 난제에 봉착하더라도 <br />
            <span class="primary--text">심도 있는 실무적 관점으로 다가가겠습니다.</span>
        </tit>
        <span data-aos="fade-up" data-aos-delay="100" class="line my-12px my-md-24px"></span>
        <txt data-aos="fade-up" data-aos-delay="200" class="white--text line-height-17">
            <p>윤영환 변호사는 건설 전공자 출신으로 건축시공기술사와 토목기사를 취득하여 활동하고 있는 실무가 출신의 대표변호사로서, 각 분야에 심도 있는 이해를 추구하고 의뢰인과 가깝게 호흡하는 현장 밀착형 로펌을 추구합니다.</p>
            <p>
                기존에 한계라 여겼던 부분들을 실무적 관점으로 풀어가는 변호사인 만큼, 풀리지 않는 난제에 봉착하였다면, <br class="d-none d-xl-block" />
                언제든지 윤영환 대표변호사를 찾아 주시기 바랍니다.
            </p>
        </txt>
    </div>
</template>

<script>
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    components: {
        Tit,
        Txt,
    },
};
</script>